$(window).ready(function () {

    let playButton = $('[data-play]');

    // start video on click
    playButton.on('click', function(event){
        let video = $(this).siblings('video').get(0);

        video.controls = false;
        let promise = video.play();
        if (promise !== undefined) {
            promise.then(_ => {
                // Autoplay started!
            }).catch(error => {
                // Autoplay was prevented.
                // Show a "Play" button so that user can start playback.
            });
        }

    });

    playButton.siblings('video').on('play', function () {
        $(this).siblings('[data-play]').hide();
    })

});
